module.exports = __webpack_public_path__ + "fonts/Manrope-600-cyrillic-ext13_6b3b5bc.woff2";